import SlideApi from '@/api/slide'

const patchSlideByIdAction = ({ commit, state }, slide) => {
  const { id: slideId } = slide

  if (slideId === state.activeSlideId) {
    commit('updateSlideActive', slide)
    return
  }

  const { slides } = state.presentation

  const newSlides = slides.map((item) => {
    if (item.id !== slideId) return item

    return { ...item, ...slide }
  })

  commit('setSlides', newSlides)
}

const updateSlidesVersionAction = ({ commit, state }, { newSlideVersions }) => {
  if (!newSlideVersions || !newSlideVersions.length) return
  newSlideVersions.forEach((slide) => {
    if (state.activeSlideId == slide.id) {
      commit('updateSlideActive', {
        id: slide.id,
        version: slide.version,
      })
    }
    commit('updateSlideById', {
      id: slide.id,
      version: slide.version,
    })
  })
}

const updateSlideActiveActionV2 = async ({ commit, state }, { slide, $optimistic = true }) => {
  const slideId = slide.id || state.slideActive.id
  if (!slideId) return
  if ($optimistic) {
    commit('updateSlideActive', slide)
  }

  await SlideApi.updateSlideById(slideId, slide)
  commit('updateSlideActive', slide)
}

export default {
  patchSlideByIdAction,
  updateSlidesVersionAction,
  updateSlideActiveActionV2,
}
